import api from '@/api/api';

export default {

    namespaced: true,

    state: {

    },
    mutations: {


    },
    actions: {


        async insertDireccionDest({ }, dest) {
            try {
                const res = await api.insertDireccionDest(dest);
                if (res.data.INFO.cod === '200') {
                    return [true];
                } return [false, res.data.INFO.msg];
            } catch (error) {
                console.log(error);
            }
        },

        async insertDireccionRem({ }, rem) {
            try {
                const res = await api.insertDireccionRem(rem);
                if (res.data.INFO.cod === '200') {
                    return [true];
                } return [false, res.data.INFO.msg];
            } catch (error) {
                console.log(error);
            }
        },



    },
};
